module.exports = __webpack_public_path__ + "static/media/class-selector-barbarian.05601291.png";